import './polyfillProcess';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/shadcn-tokens.css';
import './styles/design-tokens.css';
import './styles/mixins.css';
import './styles/utils.css';
import './styles/global.css';
import './style/index.css';
import App from './App';

// Aborting an in-flight request when a component unmounts is expected, not a
// failure. React 18's StrictMode mounts, unmounts and remounts every effect in
// development, so each cleanup aborts a request and the resulting rejection
// surfaced as an uncaught error (64 per pass over the dashboard) that covered
// the screen with the dev-server overlay. 45 files call fetch directly, so this
// is handled in one place instead of touching each of them. Only AbortError is
// swallowed; every other rejection still reaches the console.
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.name === 'AbortError') {
    event.preventDefault();
  }
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
